import styled from 'styled-components';

const RootContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export default RootContainer;
